// import { useEffect, useMemo, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//     ArrowDownLeft,
//     ArrowUpRight,
//     Diamond,
//     Inbox,
//     Loader2,
// } from "lucide-react";
// import { useHeaderAction } from "../../../core/provider/HeaderActionProvider/HeaderAction.js";
// import HeaderSubPages from "../../../components/ui/HeaderSubPages/index.js";
// import { useGetCustomerTransactionsInfinite } from "../../../core/api/customer/transaction/queries.js";
// import type { CustomerTransactionItem } from "../../../core/api/customer/transaction/api.js";
// import { cn } from "../../../lib/cn.js";

// // ============================================
// // ✅ فرمت اعداد
// // ============================================
// const fmtFa = (v: any) => new Intl.NumberFormat("fa-IR").format(Number(v ?? 0));

// // ============================================
// // ✅ بررسی وجود مقدار عددی
// // ============================================
// const hasValue = (v: number | null | undefined): v is number =>
//     v !== null && v !== undefined;

// // ============================================
// // ✅ تشخیص نوع تاریخ + مقدار
// // اولویت: paymentDate → releaseDate → transactionDate
// // ============================================
// const getDisplayDate = (
//     tx: CustomerTransactionItem
// ): { label: string; value: string } => {
//     if (tx.paymentDate) {
//         return { label: "تاریخ پرداخت", value: tx.paymentDate };
//     }
//     if (tx.releaseDate) {
//         return { label: "تاریخ سررسید", value: tx.releaseDate };
//     }
//     if (tx.transactionDate) {
//         return { label: "تاریخ تراکنش", value: tx.transactionDate };
//     }
//     return { label: "تاریخ", value: "—" };
// };

// // ============================================
// // ✅ رنگ وضعیت (ACCEPTED / PENDING / FAILED)
// // ============================================
// const getStatusConfig = (status: string) => {
//     switch (status) {
//         case "ACCEPTED":
//             return {
//                 label: "تایید شده",
//                 cls: "bg-emerald-50 text-emerald-700 border-emerald-200",
//                 dot: "bg-emerald-500",
//             };
//         case "PENDING":
//             return {
//                 label: "در انتظار",
//                 cls: "bg-amber-50 text-amber-700 border-amber-200",
//                 dot: "bg-amber-500",
//             };
//         case "FAILED":
//             return {
//                 label: "ناموفق",
//                 cls: "bg-rose-50 text-rose-700 border-rose-200",
//                 dot: "bg-rose-500",
//             };
//         default:
//             return {
//                 label: status || "—",
//                 cls: "bg-neutral-50 text-neutral-600 border-neutral-200",
//                 dot: "bg-neutral-400",
//             };
//     }
// };

// // ============================================
// // ✅ کارت تراکنش
// // ============================================
// function TransactionCard({ tx }: { tx: CustomerTransactionItem }) {
//     const statusCfg = getStatusConfig(tx.transactionStatus);
//     const isPayment = tx.transactionAbout === "PAYMENT";
//     const dateInfo = getDisplayDate(tx);

//     const showAmount = hasValue(tx.amount);
//     const showFee = hasValue(tx.fee);
//     const showCount = hasValue(tx.count);

//     return (
//         <div className="rounded-2xl bg-white border border-neutral-200 p-3.5 flex flex-col gap-2.5">
//             {/* ردیف بالا */}
//             <div className="flex items-center justify-between gap-2">
//                 <div className="flex items-center gap-2 min-w-0">
//                     <div
//                         className={cn(
//                             "w-8 h-8 rounded-xl flex items-center justify-center shrink-0",
//                             isPayment
//                                 ? "bg-rose-50 text-rose-600"
//                                 : "bg-emerald-50 text-emerald-600"
//                         )}
//                     >
//                         {isPayment ? (
//                             <ArrowUpRight className="w-4 h-4" />
//                         ) : (
//                             <ArrowDownLeft className="w-4 h-4" />
//                         )}
//                     </div>
//                     <div className="min-w-0">
//                         <p className="text-[12px] font-bold text-neutral-900 truncate">
//                             {tx.description || tx.transactionType || "تراکنش"}
//                         </p>
//                     </div>
//                 </div>

//                 <span
//                     className={cn(
//                         "inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[9px] font-bold border shrink-0",
//                         statusCfg.cls
//                     )}
//                 >
//                     <span className={cn("w-1 h-1 rounded-full", statusCfg.dot)} />
//                     {statusCfg.label}
//                 </span>
//             </div>

//             {/* ردیف تاریخ */}
//             <div className="flex items-center justify-between gap-2 text-[11px]">
//                 <span className="text-neutral-400">{dateInfo.label}</span>
//                 <span className="font-semibold text-neutral-700 tabular-nums">
//                     {dateInfo.value}
//                 </span>
//             </div>

//             {/* ردیف پایین: مبلغ / کارمزد / الماس — همیشه هر سه */}
//             <div className="flex flex-col gap-1.5 pt-2 border-t border-neutral-100">
//                 {/* مبلغ */}
//                 <div className="flex items-center justify-between gap-2">
//                     <span className="text-[11px] text-neutral-400">مبلغ</span>
//                     {showAmount ? (
//                         <span className="inline-flex items-center gap-1 font-black tabular-nums text-[13px] text-neutral-800">
//                             {fmtFa(tx.amount)}
//                             <span className="text-[9px] text-neutral-400 font-medium">
//                                 ریال
//                             </span>
//                         </span>
//                     ) : (
//                         <span className="font-black text-[13px] text-neutral-400">-</span>
//                     )}
//                 </div>

//                 {/* کارمزد */}
//                 <div className="flex items-center justify-between gap-2">
//                     <span className="text-[11px] text-neutral-400">فی</span>
//                     {showFee ? (
//                         <span className="inline-flex items-center gap-1 font-black tabular-nums text-[13px] text-sky-600">
//                             {fmtFa(tx.fee)}
//                             <span className="text-[9px] text-neutral-400 font-medium">
//                                 ریال
//                             </span>
//                         </span>
//                     ) : (
//                         <span className="font-black text-[13px] text-neutral-400">-</span>
//                     )}
//                 </div>

//                 {/* الماس */}
//                 <div className="flex items-center justify-between gap-2">
//                     <span className="text-[11px] text-neutral-400">تعداد الماس</span>
//                     {showCount ? (
//                         <span className="inline-flex items-center gap-1 font-black tabular-nums text-[13px] text-violet-600">
//                             {fmtFa(tx.count)}
//                             <Diamond className="w-3 h-3" />
//                         </span>
//                     ) : (
//                         <span className="font-black text-[13px] text-neutral-400">-</span>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// }

// // ============================================
// // ✅ صفحه اصلی لیست تراکنش‌ها
// // ============================================
// export default function CustomerTransactionsPage() {
//     const navigate = useNavigate();
//     const { setAction } = useHeaderAction();
//     const loadMoreRef = useRef<HTMLDivElement | null>(null);

//     const {
//         data,
//         isLoading,
//         isError,
//         fetchNextPage,
//         hasNextPage,
//         isFetchingNextPage,
//         refetch,
//     } = useGetCustomerTransactionsInfinite({ size: 10 });

//     const transactions = useMemo(
//         () => data?.pages.flatMap((p) => p?.payload ?? []) ?? [],
//         [data]
//     );

//     // هدر
//     useEffect(() => {
//         setAction(
//             <HeaderSubPages title="تراکنش‌ها" onBack={() => navigate(-1)} />
//         );
//         return () => setAction(null);
//     }, [navigate, setAction]);

//     // Infinite scroll
//     useEffect(() => {
//         const el = loadMoreRef.current;
//         if (!el) return;

//         const observer = new IntersectionObserver(
//             (entries: any) => {
//                 if (entries[0].isIntersecting && hasNextPage && !isFetchingNextPage) {
//                     fetchNextPage();
//                 }
//             },
//             { rootMargin: "200px" }
//         );

//         observer.observe(el);
//         return () => observer.disconnect();
//     }, [hasNextPage, isFetchingNextPage, fetchNextPage]);



//     // ===== خطا =====
//     if (isError) {
//         return (
//             <div className="flex flex-col items-center justify-center h-full gap-3 text-neutral-400">
//                 <Inbox className="w-10 h-10 text-rose-300" />
//                 <p className="text-sm">خطا در دریافت تراکنش‌ها</p>
//                 <button
//                     onClick={() => refetch()}
//                     className="px-3 py-1.5 rounded-lg bg-brand-50 text-brand-600 text-[11px] font-bold"
//                 >
//                     تلاش مجدد
//                 </button>
//             </div>
//         );
//     }

//     // ===== خالی =====
//     if (transactions.length === 0) {
//         return (
//             <div className="flex flex-col items-center justify-center h-full gap-2 text-neutral-400">
//                 <Inbox className="w-12 h-12 text-neutral-300" />
//                 <p className="text-sm font-medium">تراکنشی یافت نشد</p>
//                 <p className="text-xs">هنوز تراکنشی برای شما ثبت نشده است</p>
//             </div>
//         );
//     }

//     return (
//         <div className="flex flex-col h-full">
//             <div className="flex-1 min-h-0 overflow-auto p-3 space-y-2.5">
//                 {transactions.map((tx) => (
//                     <TransactionCard key={tx.uuid} tx={tx} />
//                 ))}

//                 {/* Sentinel برای Infinite Scroll */}
//                 <div ref={loadMoreRef} className="h-4" />

//                 {isFetchingNextPage && (
//                     <div className="flex items-center justify-center py-4">
//                         <Loader2 className="w-5 h-5 text-brand-500 animate-spin" />
//                     </div>
//                 )}

//                 {!hasNextPage && transactions.length > 0 && (
//                     <p className="text-center text-[11px] text-neutral-400 py-3">
//                         پایان لیست
//                     </p>
//                 )}
//             </div>
//         </div>
//     );
// }

import { useEffect, useMemo, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
    ArrowDownLeft,
    ArrowUpRight,
    Diamond,
    Gem,
    Inbox,
    Loader2,
} from "lucide-react";
import { useHeaderAction } from "../../../core/provider/HeaderActionProvider/HeaderAction.js";
import HeaderSubPages from "../../../components/ui/HeaderSubPages/index.js";
import {
    useGetCustomerTransactionsInfinite,
    type WalletKind,
} from "../../../core/api/customer/transaction/queries.js";
import type { CustomerTransactionItem } from "../../../core/api/customer/transaction/api.js";
import { cn } from "../../../lib/cn.js";

// ============================================
// ✅ فرمت اعداد
// ============================================
const fmtFa = (v: any) => new Intl.NumberFormat("fa-IR").format(Number(v ?? 0));

// ============================================
// ✅ بررسی وجود مقدار عددی
// ============================================
const hasValue = (v: number | null | undefined): v is number =>
    v !== null && v !== undefined;

// ============================================
// ✅ تشخیص نوع تاریخ + مقدار
// اولویت: paymentDate → releaseDate → transactionDate
// ============================================
const getDisplayDate = (
    tx: CustomerTransactionItem
): { label: string; value: string } => {
    if (tx.paymentDate) {
        return { label: "تاریخ پرداخت", value: tx.paymentDate };
    }
    if (tx.releaseDate) {
        return { label: "تاریخ سررسید", value: tx.releaseDate };
    }
    if (tx.transactionDate) {
        return { label: "تاریخ تراکنش", value: tx.transactionDate };
    }
    return { label: "تاریخ", value: "—" };
};

// ============================================
// ✅ رنگ وضعیت (ACCEPTED / PENDING / FAILED)
// ============================================
const getStatusConfig = (status: string) => {
    switch (status) {
        case "ACCEPTED":
            return {
                label: "تایید شده",
                cls: "bg-emerald-50 text-emerald-700 border-emerald-200",
                dot: "bg-emerald-500",
            };
        case "PENDING":
            return {
                label: "در انتظار",
                cls: "bg-amber-50 text-amber-700 border-amber-200",
                dot: "bg-amber-500",
            };
        case "FAILED":
            return {
                label: "ناموفق",
                cls: "bg-rose-50 text-rose-700 border-rose-200",
                dot: "bg-rose-500",
            };
        default:
            return {
                label: status || "—",
                cls: "bg-neutral-50 text-neutral-600 border-neutral-200",
                dot: "bg-neutral-400",
            };
    }
};

// ============================================
// ✅ کارت تراکنش
// ============================================
function TransactionCard({ tx }: { tx: CustomerTransactionItem }) {
    const statusCfg = getStatusConfig(tx.transactionStatus);
    const isPayment = tx.transactionAbout === "PAYMENT";
    const dateInfo = getDisplayDate(tx);

    const showAmount = hasValue(tx.amount);
    const showFee = hasValue(tx.fee);
    const showCount = hasValue(tx.count);

    return (
        <div className="rounded-2xl bg-white border border-neutral-200 p-3.5 flex flex-col gap-2.5">
            {/* ردیف بالا */}
            <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 min-w-0">
                    <div
                        className={cn(
                            "w-8 h-8 rounded-xl flex items-center justify-center shrink-0",
                            isPayment
                                ? "bg-rose-50 text-rose-600"
                                : "bg-emerald-50 text-emerald-600"
                        )}
                    >
                        {isPayment ? (
                            <ArrowUpRight className="w-4 h-4" />
                        ) : (
                            <ArrowDownLeft className="w-4 h-4" />
                        )}
                    </div>
                    <div className="min-w-0">
                        <p className="text-[12px] font-bold text-neutral-900 truncate">
                            {tx.description || tx.transactionType || "تراکنش"}
                        </p>
                    </div>
                </div>

                <span
                    className={cn(
                        "inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[9px] font-bold border shrink-0",
                        statusCfg.cls
                    )}
                >
                    <span className={cn("w-1 h-1 rounded-full", statusCfg.dot)} />
                    {statusCfg.label}
                </span>
            </div>

            {/* ردیف تاریخ */}
            <div className="flex items-center justify-between gap-2 text-[11px]">
                <span className="text-neutral-400">{dateInfo.label}</span>
                <span className="font-semibold text-neutral-700 tabular-nums">
                    {dateInfo.value}
                </span>
            </div>

            {/* ردیف پایین: مبلغ / کارمزد / الماس — همیشه هر سه */}
            <div className="flex flex-col gap-1.5 pt-2 border-t border-neutral-100">
                {/* مبلغ */}
                <div className="flex items-center justify-between gap-2">
                    <span className="text-[11px] text-neutral-400">مبلغ</span>
                    {showAmount ? (
                        <span className="inline-flex items-center gap-1 font-black tabular-nums text-[13px] text-neutral-800">
                            {fmtFa(tx.amount)}
                            <span className="text-[9px] text-neutral-400 font-medium">
                                ریال
                            </span>
                        </span>
                    ) : (
                        <span className="font-black text-[13px] text-neutral-400">-</span>
                    )}
                </div>

                {/* کارمزد */}
                <div className="flex items-center justify-between gap-2">
                    <span className="text-[11px] text-neutral-400">فی</span>
                    {showFee ? (
                        <span className="inline-flex items-center gap-1 font-black tabular-nums text-[13px] text-sky-600">
                            {fmtFa(tx.fee)}
                            <span className="text-[9px] text-neutral-400 font-medium">
                                ریال
                            </span>
                        </span>
                    ) : (
                        <span className="font-black text-[13px] text-neutral-400">-</span>
                    )}
                </div>

                {/* الماس */}
                <div className="flex items-center justify-between gap-2">
                    <span className="text-[11px] text-neutral-400">تعداد الماس</span>
                    {showCount ? (
                        <span className="inline-flex items-center gap-1 font-black tabular-nums text-[13px] text-violet-600">
                            {fmtFa(tx.count)}
                            <Gem className="w-3 h-3" />
                        </span>
                    ) : (
                        <span className="font-black text-[13px] text-neutral-400">-</span>
                    )}
                </div>
            </div>
        </div>
    );
}

// ============================================
// ✅ صفحه اصلی لیست تراکنش‌ها
// ============================================
export default function CustomerTransactionsPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { setAction } = useHeaderAction();
    const loadMoreRef = useRef<HTMLDivElement | null>(null);

    // ✅ تشخیص نوع کیف پول از URL
    const wallet: WalletKind =
        searchParams.get("wallet") === "blocked" ? "blocked" : "free";

    const {
        data,
        isLoading,
        isError,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        refetch,
    } = useGetCustomerTransactionsInfinite({ wallet });

    const transactions = useMemo(
        () => data?.pages.flatMap((p) => p?.payload ?? []) ?? [],
        [data]
    );

    // هدر — عنوان بر اساس نوع کیف پول
    useEffect(() => {
        setAction(
            <HeaderSubPages
                title={
                    wallet === "blocked"
                        ? "تراکنش‌های کیف پول بلاک‌شده"
                        : "تراکنش‌های کیف پول آزاد"
                }
                onBack={() => navigate(-1)}
            />
        );
        return () => setAction(null);
    }, [navigate, setAction, wallet]);

    // Infinite scroll
    useEffect(() => {
        const el = loadMoreRef.current;
        if (!el) return;

        const observer = new IntersectionObserver(
            (entries: any) => {
                if (entries[0].isIntersecting && hasNextPage && !isFetchingNextPage) {
                    fetchNextPage();
                }
            },
            { rootMargin: "200px" }
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, [hasNextPage, isFetchingNextPage, fetchNextPage]);


    // ===== خطا =====
    if (isError) {
        return (
            <div className="flex flex-col items-center justify-center h-full gap-3 text-neutral-400">
                <Inbox className="w-10 h-10 text-rose-300" />
                <p className="text-sm">خطا در دریافت تراکنش‌ها</p>
                <button
                    onClick={() => refetch()}
                    className="px-3 py-1.5 rounded-lg bg-brand-50 text-brand-600 text-[11px] font-bold"
                >
                    تلاش مجدد
                </button>
            </div>
        );
    }

    // ===== خالی =====
    if (transactions.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center h-full gap-2 text-neutral-400">
                <Inbox className="w-12 h-12 text-neutral-300" />
                <p className="text-sm font-medium">تراکنشی یافت نشد</p>
                <p className="text-xs">هنوز تراکنشی برای شما ثبت نشده است</p>
            </div>
        );
    }

    return (
        <div className="flex flex-col h-full">
            <div className="flex-1 min-h-0 overflow-auto p-3 space-y-2.5">
                {transactions.map((tx) => (
                    <TransactionCard key={tx.uuid} tx={tx} />
                ))}

                {/* Sentinel برای Infinite Scroll */}
                <div ref={loadMoreRef} className="h-4" />

                {isFetchingNextPage && (
                    <div className="flex items-center justify-center py-4">
                        <Loader2 className="w-5 h-5 text-brand-500 animate-spin" />
                    </div>
                )}

                {!hasNextPage && transactions.length > 0 && (
                    <p className="text-center text-[11px] text-neutral-400 py-3">
                        پایان لیست
                    </p>
                )}
            </div>
        </div>
    );
}